import { defineComponent as _defineComponent } from 'vue'
import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "hourly-wage-input" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = ["value", "disabled"]
const _hoisted_4 = ["disabled"]

import { useHoldRepeat } from '@/composables/wage/useHoldRepeat';
import { formatWageNumber, parseWageNumber } from '@/composables/wage/useWageCalculator';


export default /*@__PURE__*/_defineComponent({
  __name: 'CommonWageHourlyInput',
  props: {
    modelValue: {},
    minHourlyWage: { default: 0 },
    disabled: { type: Boolean, default: false }
  },
  emits: ["update:modelValue", "blur"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const clampHourly = (value: number): number => {
  const min = props.minHourlyWage ?? 0;
  let next = value;
  if (min > 0 && next < min) {
    next = min;
  }
  if (next < 0) {
    next = 0;
  }
  return next;
};

const applyDelta = (delta: number) => {
  const current = parseWageNumber(props.modelValue);
  emit('update:modelValue', formatWageNumber(clampHourly(current + delta)));
};

const holdUp = useHoldRepeat(() => applyDelta(1));
const holdDown = useHoldRepeat(() => applyDelta(-1));

const onHoldStart = (delta: number) => {
  if (props.disabled) return;
  (delta > 0 ? holdUp : holdDown).start();
};

const holdStop = () => {
  holdUp.stop();
  holdDown.stop();
};

const onInput = (e: Event) => {
  const raw = (e.target as HTMLInputElement).value.replace(/[^\d]/g, '');
  const num = raw ? parseInt(raw, 10) : 0;
  emit('update:modelValue', num ? formatWageNumber(num) : '');
};

const onBlur = () => {
  const hourly = parseWageNumber(props.modelValue);
  const min = props.minHourlyWage ?? 0;
  if (min > 0 && hourly > 0 && hourly < min) {
    alert(`시급은 최저시급(${formatWageNumber(min)}원) 이상이어야 합니다.`);
    emit('update:modelValue', formatWageNumber(min));
  }
  emit('blur');
};

const onFocus = (e: Event) => {
  const el = e.target as HTMLInputElement;
  setTimeout(() => el.select(), 0);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      type: "button",
      class: "wage-btn minus",
      "aria-label": "시급 1원 감소",
      disabled: __props.disabled,
      onMousedown: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (onHoldStart(-1)), ["prevent"])),
      onMouseup: holdStop,
      onMouseleave: holdStop,
      onTouchstart: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (onHoldStart(-1)), ["prevent"])),
      onTouchend: holdStop,
      onTouchcancel: holdStop
    }, " - ", 40, _hoisted_2),
    _createElementVNode("input", {
      value: __props.modelValue,
      type: "text",
      disabled: __props.disabled,
      onInput: onInput,
      onBlur: onBlur,
      onFocus: onFocus,
      onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
    }, null, 40, _hoisted_3),
    _createElementVNode("button", {
      type: "button",
      class: "wage-btn plus",
      "aria-label": "시급 1원 증가",
      disabled: __props.disabled,
      onMousedown: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (onHoldStart(1)), ["prevent"])),
      onMouseup: holdStop,
      onMouseleave: holdStop,
      onTouchstart: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (onHoldStart(1)), ["prevent"])),
      onTouchend: holdStop,
      onTouchcancel: holdStop
    }, " + ", 40, _hoisted_4)
  ]))
}
}

})